import { render, staticRenderFns } from "./CompanyConfirm.vue?vue&type=template&id=558ae8ae&"
import script from "./CompanyConfirm.vue?vue&type=script&lang=js&"
export * from "./CompanyConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports